export default class CustomField {
    id: bigint | null
    uuid: string | null
    model: string
    type: string
    title: string
    description: string
    defaultValue: string | null
    required: boolean
    additional: object
    backgroundTasks: []
    createdAt: string | null
    updatedAt: string | null

    constructor(data: any) {
        this.id = data?.id ?? null;
        this.uuid = data?.uuid ?? null;
        this.model = data?.model ?? '';
        this.type = data?.type ?? '';
        this.title = data?.title ?? '';
        this.description = data?.description ?? '';
        this.defaultValue = data?.default_value ?? null;
        this.required = data?.required ?? false;
        this.additional = data?.additional ?? {};
        this.backgroundTasks = data?.background_tasks ?? [];
        this.createdAt = data?.created_at ?? null;
        this.updatedAt = data?.updated_at ?? null;
    }
}